// extracted by mini-css-extract-plugin
module.exports = {"userRank":"UserRank_userRank__7xFfH","bronze":"UserRank_bronze__16Oao","gold":"UserRank_gold__2mkyN","silver":"UserRank_silver__2dpNW","platinum":"UserRank_platinum__16s8W"};